import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Config from "../../../config/config";
import { refreshAccessToken } from "../../Authorization/authSlice";

const serverPath = Config.serverPath;
//CREATE ITEM LIBRARY
export const idLibraryCreate = createAsyncThunk(
    "library/idLibraryCreate",  async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/library/add";
        const urlToFetch = `${url}`;
        const response = await fetch(urlToFetch, {
            method: 'POST',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                writers: item.writers,
                titles: item.titles,
                category: item.category,
                year: item.year,
                content: item.content
            })
        });
        if (response.ok) {
            const answer = await response.json();
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(idLibraryCreate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD CREATE ITEM library');
      return response.status;
      }
        
    }
);
// GET ALL LIBRARY

export const getLibrary = createAsyncThunk(
    "library/getLibrary", async(_arg, thunkApi) => {
        const {dispatch} = thunkApi;
        const url = serverPath + "/api/library/load/";
        const urlToFetch = url;
        console.log('start get library!');
        const response = await fetch(urlToFetch
            , {
            method: 'GET',
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
          
           credentials: 'include',
            mode: 'cors',
        });
        console.log(response);
        let dataLibrary = [];
        if (response.ok) {
            const jsonResponse = await response.json();
            dataLibrary = jsonResponse;
           // console.log(jsonResponse);
           return dataLibrary;

           //REFRESH ACCESS TOKEN IF 401
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(getLibrary());
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD GET library');
      return response.status;
      }
    }
);

//DELETE ID LIBRARY
export const idLibraryDelete = createAsyncThunk(
    "library/idLibraryDelete", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/library/delete/";
        const urlToFetch = `${url}${item.library_id}`;
        const response = await fetch(urlToFetch, {
            method: 'DELETE',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                library_id: item.library_id,
                //main_name: item.main_name
                               
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer);
           return answer;
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(idLibraryDelete(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD DELETE ITEM library');
      return response.status;
      }

    }
);
//UPDATE ID LIBRARY
export const idLibraryUpdate = createAsyncThunk(
    "library/idLibraryUpdate", async(item, thunkApi) => {
        const {dispatch} = thunkApi;
        console.log(item);
        const url = serverPath + "/api/library/update/";
        const urlToFetch = `${url}${item.id}`;
        const response = await fetch(urlToFetch, {
            method: 'PUT',
            headers: {"Content-Type": "application/json; charset=utf-8",
                "Authorization": `Bearer ${localStorage.getItem('token')}`,
            },
            body: JSON.stringify({
                id: item.id,
                writers: item.writers,
                titles:item.titles,
                category: item.category,
                year: item.year,
                content: item.content,
                
            })
        });
        
         if (response.ok) {
            const answer = await response.json();
           
            console.log('Успех:', JSON.stringify(answer));
            console.log(answer[0]);
           return answer[0];
        } else if (response.status === 401) {
          
            console.log('401 -refresh access token!');
            try {
                const result = await dispatch(refreshAccessToken());
              //IF ACCESS AND REFRESH TOKEN BAD
                console.log(result.payload);
                if (result.payload) {
                   // console.log('GOOD ACCESS!!!!');
                  dispatch(idLibraryUpdate(item));
                } else {
                    console.log('Bad refresh access');
                }
            } catch (e) {
                console.log('Error');
            };
        
        } else {
           
        console.log('BAD UPDATE ITEM library');
      return response.status;
      }

    }
);


//INITIAL STATE
const initialState ={
    libraryView: false,
    libraryContent: [],
    selectedIdLibrary: null,
    selectedLibraryContent:{
        writers:'',
        titles: '',
        category: '',
        year: '',
        content: '',
    },
};

const options = {
    name: 'library',
    initialState: {
    libraryContent: [],
    selectedId: null,
    selectedLibraryContent:{
        writers:'',
        titles: '',
        category: '',
        year: '',
        content: '',
    },
    },
reducers: {
    getInitialState: state  => 
    initialState,

    openLibraryForm: (state) => {
    state.libraryView = true;
},
    selectedIdLibrary: (state, action) => {
        state.selectedIdLibrary = action.payload;
    },
    selectedLibraryContent: (state, action) => {
        state.selectedLibraryContent.writers = action.payload.writers;
        state.selectedLibraryContent.titles = action.payload.titles;
        state.selectedLibraryContent.category = action.payload.category;
        state.selectedLibraryContent.year = action.payload.year;
        state.selectedLibraryContent.content = action.payload.content;
    },

   
},
extraReducers(builder) {
    builder
    //ADD ITEM LIBRARY
    .addCase(idLibraryCreate.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(idLibraryCreate.fulfilled, (state, action) => {
        console.log(action.payload);
        if (action.payload) {
        state.libraryContent.push({
            id: action.payload.id,
            writers: action.payload.writers,
            titles: action.payload.titles,
                category: action.payload.category,
                year: action.payload.year,
                score: action.payload.score,
                content: action.payload.content,
                
        });
        }
        state.isFetching = true;
        state.error = false;
    })
    .addCase(idLibraryCreate.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong!!!");
    })
    //LOAD LIBRARY
    .addCase(getLibrary.pending, (state) => {
        state.isFetching = true;
        state.error = false;
    })
    .addCase(getLibrary.fulfilled, (state, action) => {

        console.log(action.payload);
        if (action.payload) {
        state.libraryContent = action.payload;
        state.isFetching = true;
        state.error = false;
        }
    })
    .addCase(getLibrary.rejected, (state, action) => {
        state.isFetching = false;
        state.error = action.payload;
        console.log("oh wrong get library rejected!!!");
    })
    //DELETE ID LIBRARY
             
             .addCase(idLibraryDelete.pending, (state, action) => {
                state.isFetching = true;
                state.error = false;
            })
            .addCase(idLibraryDelete.fulfilled, (state, action) => {
                console.log(action.payload);
                if (action.payload) {
                    if (action.payload.length === 0 ) {
                    const index = state.libraryContent.findIndex(item => item.id === Number(state.selectedIdLibrary));
                    
                    console.log(index);

                    if (index !== -1) {
                        console.log('delete item libr from state');
                        state.libraryContent.splice(index, 1);
                    }
                    }
                }

                state.isFetching = true;
                state.error= false;
            })
            .addCase(idLibraryDelete.rejected, (state, action) => {
                state.isFetching = false;
                state.error = action.payload;
                console.log("oh wrong!!!");
            })
             //UPDATE ID LIBRARY
        .addCase(idLibraryUpdate.pending, (state, action) => {
            state.isFetching = true;
            state.error = false;
        })
        .addCase(idLibraryUpdate.fulfilled, (state, action) => {
            if (action.payload) {
          state.libraryContent.map(item => {
                if ( item.id === action.payload.id) {
                    item.writers = action.payload.writers;
                    item.titles = action.payload.titles;
                    item.content = action.payload.content;
                    item.year = action.payload.year;
                    item.category = action.payload.category;
                } else return null;
                return item;
            });
        }
            state.isFetching = true;
            state.error= false;
        })
        .addCase(idLibraryUpdate.rejected, (state, action) => {
            state.isFetching = false;
            state.error = action.payload;
            console.log("oh wrong!!!");
        })
    
}

        

};

export const  librarySlice = createSlice(options);
export const {selectedIdLibrary, selectedLibraryContent} = librarySlice.actions;
export default librarySlice.reducer;


